import React from "react";

interface LogoProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  alt?: string;
}

export const AFSLogo = ({
  className = "",
  width = 100,
  height = 41,
  alt = "AFS Logo",
}: LogoProps) => {
  return (
    <svg
      id='Layer_2'
      data-name='Layer 2'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 949.09 388.92'
      className={className}
      width={width}
      height={height}
      role='img'
      aria-labelledby='AFS Logo'
    >
      <title id='logoTitle'>{alt}</title>
      <g id='Layer_2-2' data-name='Layer 2'>
        <g>
          <path
            className='fill-foreground'
            d='M668.05,388.55c5.47-12.5,10.65-24.33,15.82-36.17,3.95-9.05,8.09-18.02,11.73-27.19,1.6-4.04,3.84-5.29,8.15-5.28,54.74.1,109.48-.01,164.22-.06,2.11,0,4.23,0,6.85,0v-90.52h-6.35c-47.95,0-95.89.03-143.84-.02-12.31-.01-24.52-.95-35.25-7.89-12.02-7.78-16.62-19.78-16.9-33.3-.48-22.86-.19-45.74-.21-68.61-.02-24.81-.15-49.62.05-74.42.13-16.38,4.58-31.29,20.66-38.64,8.04-3.68,17.51-5.79,26.37-5.89,49.1-.57,98.22-.3,147.33-.3.76,0,1.52.19,3.04.39-2.02,6.23-3.98,12.22-5.9,18.23-4.83,15.1-9.78,30.17-14.35,45.35-1.22,4.04-3.04,5.31-7.27,5.28-29.89-.2-59.79-.11-89.68-.09-2.09,0-4.17.18-6.49.28v90.83c2.65,0,4.92,0,7.2,0,48.92,0,97.83-.06,146.75.08,5.97.02,12.07.51,17.88,1.81,18.11,4.05,28.96,16.88,30.63,35.56.39,4.43.56,8.89.56,13.34.04,42.83.11,85.67-.07,128.5-.03,6.53-.51,13.27-2.13,19.56-4.6,17.77-18.22,27.7-38.85,29.21-3.09.23-6.21.26-9.31.26-74.73.02-149.47.02-224.2.02-1.87,0-3.73-.15-6.43-.27Z'
          />
          <path
            className='fill-foreground'
            d='M0,388.82c6.91-18.12,13.44-35.25,19.96-52.39C58.08,236.31,96.1,136.15,134.41,36.11c5.96-15.57,14.93-29.12,32.45-33.91,11.48-3.14,23.1-2.89,34.45.55,10.09,3.06,16.78,10.12,20.61,19.85,15.16,38.53,30.3,77.06,45.42,115.6,23.25,59.24,46.48,118.48,69.71,177.73.62,1.58,1.12,3.21,2.02,5.81-2.65,0-4.68,0-6.71,0-71.79,0-143.58.05-215.37-.14-5.53-.02-8.05,1.53-9.79,6.92-6,18.57-12.71,36.91-18.9,55.43-1.24,3.7-2.86,5.02-6.93,4.98-24.83-.22-49.67-.11-74.51-.1-1.92,0-3.84,0-6.86,0ZM182.57,104.66c-17.64,51.9-34.69,102.09-51.85,152.59h101.37c-16.5-50.84-32.78-101.02-49.51-152.59Z'
          />
          <path
            className='fill-foreground'
            d='M458.86,163.16h155.84c-2.01,23.06-3.96,45.46-5.95,68.28h-149.04v156.95h-83.07c0-2.07,0-4.13,0-6.19,0-99.98-.09-199.95.13-299.93.02-10.77,1.03-21.7,3.05-32.28,4.71-24.65,20.32-39.68,44.52-44.93,12.79-2.78,26.06-4.43,39.14-4.63,38.03-.6,76.07-.21,114.1-.19.77,0,1.53.1,2.97.2-3.17,9.91-6.24,19.6-9.36,29.26-3.62,11.22-7.49,22.38-10.84,33.68-1.17,3.96-3.22,4.93-7.03,4.94-19.59.03-39.19,0-58.77.66-5.85.2-11.86,1.98-17.39,4.08-9.54,3.64-15.34,11.62-15.97,21.23-1.51,22.71-1.63,45.51-2.33,68.88Z'
          />
          <path
            className='fill-primary'
            d='M260.11,337.71c12.59,0,24.78,0,36.97,0,13.57,0,27.15-.09,40.72.13,1.87.03,4.86,1.24,5.4,2.64,5.78,15.13,11.17,30.41,16.65,45.66.11.31-.09.73-.23,1.68-1.51.14-3.15.43-4.79.43-24.63.03-49.25-.07-73.88.1-4.21.03-5.89-1.24-7.1-5.47-3.92-13.7-8.56-27.21-12.88-40.8-.39-1.23-.51-2.55-.85-4.37Z'
          />
          <path
            className='fill-primary'
            d='M654.88,1.09c-2.5,7.74-4.91,15.21-7.31,22.67-4.14,12.87-8.36,25.72-12.37,38.64-1.11,3.58-2.61,5.18-6.81,5.11-15.71-.28-31.43-.02-47.14.01-1.32,0-2.65-.15-4.74-.29,1.44-4.78,2.71-9.18,4.09-13.54,5.14-16.2,10.31-32.38,15.49-48.57.83-2.59,1.55-4.74,5.35-4.68,16.88.25,33.76.09,50.65.1.72,0,1.45.27,2.8.54Z'
          />
          <path
            className='fill-primary'
            d='M944.18,1.09c-2.5,7.74-4.91,15.21-7.31,22.67-4.14,12.87-8.36,25.72-12.37,38.64-1.11,3.58-2.61,5.18-6.81,5.11-15.71-.28-31.43-.02-47.14.01-1.32,0-2.65-.15-4.74-.29,1.44-4.78,2.71-9.18,4.09-13.54,5.14-16.2,10.31-32.38,15.49-48.57.83-2.59,1.55-4.74,5.35-4.68,16.88.25,33.76.09,50.65.1.72,0,1.45.27,2.8.54Z'
          />
        </g>
      </g>
    </svg>
  );
};

//Adobe Logos
export const PhotoshopLogo = ({
  className = "",
  width = 100,
  height = 100,
  alt = "Adobe Photoshop Logo",
}: LogoProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 256 256'
      id='adobe-photoshop-file'
      className={className}
      role='img'
      aria-labelledby={alt}
    >
      <title id='logoTitle'>{alt}</title>
      <path
        fill='#001e36'
        d='M223,70.44V220a23.14,23.14,0,0,1-23.27,23H56.27A23.14,23.14,0,0,1,33,220V36A23.14,23.14,0,0,1,56.27,13H164.89a23.37,23.37,0,0,1,16.45,6.74l34.85,34.44A22.86,22.86,0,0,1,223,70.44Z'
      ></path>
      <path
        fill='#31a8ff'
        d='M78 137.2V59.43a.7.7 0 01.79-.8C84.48 58.48 91.21 58 100 58c10.35 0 17.93 2.19 22.77 6.91A23.52 23.52 0 01130 82.4q0 12.91-9 19.2t-22.6 6.29L92 108v29.09c0 .61-.25.91-.85.91H78.9C78.3 138 78 137.73 78 137.2zm14-68V97.27a59 59 0 017.08-.13q7.53 0 12.2-3.37t4.67-11q0-6.73-4.11-10.4T100 68.69c-1.27 0-2.53 0-3.76 0s-2.25.06-3 .06S91.92 68.8 92 69.16zM178 119.61a16 16 0 01-5.71 12.73v0c-.34.33-.7.64-1.08.95Q165.31 138 155.26 138t-16.46-3.66a1.08 1.08 0 01-.69-1.16V122.52a.69.69 0 01.29-.63.38.38 0 01.51.06 26.19 26.19 0 0015.89 5.5 10.93 10.93 0 006.11-1.42A4.35 4.35 0 00163 122.3a5.41 5.41 0 00-1.72-4.07q-1.71-1.67-6.74-3.61-9.15-3.56-12.74-7.63A14.41 14.41 0 01138 97a16.07 16.07 0 015.6-12.17Q149 80 158.91 80c6.18 0 11.16.84 14.52 2.53.38.22.57.72.57 1.48v9.51c0 .92-.34 1.15-1 .69a25.63 25.63 0 00-13.6-4q-4 0-5.88 1.49a4.42 4.42 0 00-1.89 3.55 4.89 4.89 0 001.6 3.62q1.59 1.55 6.74 3.6 9 3.48 12.88 7.3l.07.07C175.53 112.25 178 115.59 178 119.61z'
      ></path>
      <path
        fill='#fff'
        d='M86 213.62V178.49c0-.25.11-.38.32-.38q3.48-.11 9.76-.11c4.76 0 8.28 1.1 10.53 3.29a11 11 0 013.39 8.24q0 6-4.14 9a17.39 17.39 0 01-10.49 3l-1.76 0-1.61 0v12.13c0 .25-.14.38-.43.38H86.38A.34.34 0 0186 213.62zm6-30.56v13.37c1.06.08 2.11.11 3.7.11a9.15 9.15 0 005.58-1.6q2.16-1.6 2.16-5.3a6.34 6.34 0 00-1.92-4.92A7.75 7.75 0 0096.08 183C94.16 183 93 183 92 183.06zM124.47 214a18.61 18.61 0 01-9.13-2.07.83.83 0 01-.32-.74V206c0-.35.14-.42.43-.21a15.88 15.88 0 009.18 3.08 6.75 6.75 0 004.41-1.2 3.8 3.8 0 001.41-3 3.91 3.91 0 00-1.09-2.82 13 13 0 00-4.14-2.6l-2-.95a16.58 16.58 0 01-6.14-4.43 9.05 9.05 0 01-1.82-5.86 9.4 9.4 0 013.1-7.15q3.09-2.81 8.81-2.81a16.58 16.58 0 017.64 1.48c.21.08.32.29.32.64v4.82a.28.28 0 01-.11.24c-.07.06-.18 0-.32 0A14 14 0 00127 183a5.75 5.75 0 00-4.19 1.3 3.93 3.93 0 00-1.31 2.83 4.57 4.57 0 001.07 3 12.69 12.69 0 004.06 2.59l2.14 1q4.69 2.17 6.46 4.58a9.78 9.78 0 01-1.63 13Q130.24 214 124.47 214zM142 213.4V178.54a.38.38 0 01.32-.43c3.86-.07 7.28-.11 10.28-.11 5.68 0 10 1.61 13 4.82s4.44 7.45 4.44 12.69a22.39 22.39 0 01-1.15 7.46 16 16 0 01-2.95 5.31 15.08 15.08 0 01-4.28 3.36 18.43 18.43 0 01-4.92 1.84 24 24 0 01-5.06.52c-3.36 0-6.46 0-9.32-.11C142.11 213.89 142 213.73 142 213.4zM148 183V209c1.67.07 2.81.11 4 .11a10.79 10.79 0 008.3-3.23q3-3.22 3-10.17 0-6.49-2.81-9.62a10 10 0 00-7.84-3.12C150.46 182.93 149.1 183 148 183z'
      ></path>
      <path
        fill='#31a8ff'
        d='M166.06,18a13.94,13.94,0,0,1,9.9,4.1L211.9,58a13.94,13.94,0,0,1,4.1,9.9V224a14,14,0,0,1-14,14H54a14,14,0,0,1-14-14V32A14,14,0,0,1,54,18H166.06m0-10H54A24,24,0,0,0,30,32V224a24,24,0,0,0,24,24H202a24,24,0,0,0,24-24V67.94a24,24,0,0,0-7-17L183,15a24,24,0,0,0-17-7Z'
      ></path>
    </svg>
  );
};

export const IllustratorLogo = ({
  className = "",
  width = 100,
  height = 100,
  alt = "Adobe Illustrator Logo",
}: LogoProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 256 256'
      id='adobe-illustrator-file'
      className={className}
      role='img'
      aria-labelledby={alt}
    >
      <title id='logoTitle'>{alt}</title>
      <path
        fill='#300'
        d='M222,70.44V220a23,23,0,0,1-23,23H57a23,23,0,0,1-23-23V36A23,23,0,0,1,57,13H164.51a23,23,0,0,1,16.27,6.74l34.48,34.44A23,23,0,0,1,222,70.44Z'
      ></path>
      <path
        fill='#ff9a00'
        d='M166.06,18a13.94,13.94,0,0,1,9.9,4.1L211.9,58a13.94,13.94,0,0,1,4.1,9.9V224a14,14,0,0,1-14,14H54a14,14,0,0,1-14-14V32A14,14,0,0,1,54,18H166.06m0-10H54A24,24,0,0,0,30,32V224a24,24,0,0,0,24,24H202a24,24,0,0,0,24-24V67.94a24,24,0,0,0-7-17L183,15a24,24,0,0,0-17-7Z'
      ></path>
      <path
        fill='#ff9a00'
        d='M166.93 72a8.88 8.88 0 01-6.46-2.4A8.73 8.73 0 01158 63.07a8.81 8.81 0 012.54-6.6A9 9 0 01167.07 54a8.69 8.69 0 016.53 2.47 9.08 9.08 0 012.4 6.6 8.73 8.73 0 01-2.47 6.53A9.08 9.08 0 01166.93 72zM127.24 116H101.15l-6.73 21c-.09.65-.49 1-1.23 1H80.94c-.82 0-1.1-.4-.86-1.22L104 65.21a20.41 20.41 0 001-6.48.64.64 0 01.73-.73h16.88c.49 0 .77.2.85.61l26.46 78.3c.24.73 0 1.09-.61 1.09H135.57a1.28 1.28 0 01-1.23-.73zm-23.15-12h20.33L114 70zM160 136.87V79a.88.88 0 011-1h12a.88.88 0 011 1v58a.88.88 0 01-1 1H161.13A1 1 0 01160 136.87z'
      ></path>
      <path
        fill='#fff'
        d='M127.6 204H115.67l-3.08 9.56c0 .29-.22.44-.56.44h-5.6c-.37 0-.5-.18-.39-.55l10.81-32.12a9.51 9.51 0 00.44-3 .3.3 0 01.34-.33h7.84a.35.35 0 01.39.27L138 213.51c.12.33 0 .49-.28.49H131.4a.58.58 0 01-.56-.33zM117 198h9.3c-.16.23-2.77-8.07-3.36-10s-1-3.36-1.35-4.49h0C121.14 185.4 119.63 190.49 117 198zM150 178.44v35.07c0 .33-.15.49-.44.49h-5.12c-.29 0-.44-.16-.44-.49V178.44a.39.39 0 01.44-.44h5.18C149.87 178 150 178.15 150 178.44z'
      ></path>
    </svg>
  );
};

export const InDesignLogo = ({
  className = "",
  width = 100,
  height = 100,
  alt = "Adobe InDesign Logo",
}: LogoProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 256 256'
      id='adobe-indesign-file'
      className={className}
      role='img'
      aria-labelledby={alt}
    >
      <title id='logoTitle'>{alt}</title>
      <path
        fill='#001e36'
        d='M223,70.44V220a23.14,23.14,0,0,1-23.27,23H56.27A23.14,23.14,0,0,1,33,220V36A23.14,23.14,0,0,1,56.27,13H164.89a23.37,23.37,0,0,1,16.45,6.74l34.85,34.44A22.86,22.86,0,0,1,223,70.44Z'
      ></path>
      <path
        fill='#31a8ff'
        d='M78 137.2V59.43a.7.7 0 01.79-.8C84.48 58.48 91.21 58 100 58c10.35 0 17.93 2.19 22.77 6.91A23.52 23.52 0 01130 82.4q0 12.91-9 19.2t-22.6 6.29L92 108v29.09c0 .61-.25.91-.85.91H78.9C78.3 138 78 137.73 78 137.2zm14-68V97.27a59 59 0 017.08-.13q7.53 0 12.2-3.37t4.67-11q0-6.73-4.11-10.4T100 68.69c-1.27 0-2.53 0-3.76 0s-2.25.06-3 .06S91.92 68.8 92 69.16zM178 119.61a16 16 0 01-5.71 12.73v0c-.34.33-.7.64-1.08.95Q165.31 138 155.26 138t-16.46-3.66a1.08 1.08 0 01-.69-1.16V122.52a.69.69 0 01.29-.63.38.38 0 01.51.06 26.19 26.19 0 0015.89 5.5 10.93 10.93 0 006.11-1.42A4.35 4.35 0 00163 122.3a5.41 5.41 0 00-1.72-4.07q-1.71-1.67-6.74-3.61-9.15-3.56-12.74-7.63A14.41 14.41 0 01138 97a16.07 16.07 0 015.6-12.17Q149 80 158.91 80c6.18 0 11.16.84 14.52 2.53.38.22.57.72.57 1.48v9.51c0 .92-.34 1.15-1 .69a25.63 25.63 0 00-13.6-4q-4 0-5.88 1.49a4.42 4.42 0 00-1.89 3.55 4.89 4.89 0 001.6 3.62q1.59 1.55 6.74 3.6 9 3.48 12.88 7.3l.07.07C175.53 112.25 178 115.59 178 119.61z'
      ></path>
      <path
        fill='#fff'
        d='M86 213.62V178.49c0-.25.11-.38.32-.38q3.48-.11 9.76-.11c4.76 0 8.28 1.1 10.53 3.29a11 11 0 013.39 8.24q0 6-4.14 9a17.39 17.39 0 01-10.49 3l-1.76 0-1.61 0v12.13c0 .25-.14.38-.43.38H86.38A.34.34 0 0186 213.62zm6-30.56v13.37c1.06.08 2.11.11 3.7.11a9.15 9.15 0 005.58-1.6q2.16-1.6 2.16-5.3a6.34 6.34 0 00-1.92-4.92A7.75 7.75 0 0096.08 183C94.16 183 93 183 92 183.06zM124.47 214a18.61 18.61 0 01-9.13-2.07.83.83 0 01-.32-.74V206c0-.35.14-.42.43-.21a15.88 15.88 0 009.18 3.08 6.75 6.75 0 004.41-1.2 3.8 3.8 0 001.41-3 3.91 3.91 0 00-1.09-2.82 13 13 0 00-4.14-2.6l-2-.95a16.58 16.58 0 01-6.14-4.43 9.05 9.05 0 01-1.82-5.86 9.4 9.4 0 013.1-7.15q3.09-2.81 8.81-2.81a16.58 16.58 0 017.64 1.48c.21.08.32.29.32.64v4.82a.28.28 0 01-.11.24c-.07.06-.18 0-.32 0A14 14 0 00127 183a5.75 5.75 0 00-4.19 1.3 3.93 3.93 0 00-1.31 2.83 4.57 4.57 0 001.07 3 12.69 12.69 0 004.06 2.59l2.14 1q4.69 2.17 6.46 4.58a9.78 9.78 0 01-1.63 13Q130.24 214 124.47 214zM142 213.4V178.54a.38.38 0 01.32-.43c3.86-.07 7.28-.11 10.28-.11 5.68 0 10 1.61 13 4.82s4.44 7.45 4.44 12.69a22.39 22.39 0 01-1.15 7.46 16 16 0 01-2.95 5.31 15.08 15.08 0 01-4.28 3.36 18.43 18.43 0 01-4.92 1.84 24 24 0 01-5.06.52c-3.36 0-6.46 0-9.32-.11C142.11 213.89 142 213.73 142 213.4zM148 183V209c1.67.07 2.81.11 4 .11a10.79 10.79 0 008.3-3.23q3-3.22 3-10.17 0-6.49-2.81-9.62a10 10 0 00-7.84-3.12C150.46 182.93 149.1 183 148 183z'
      ></path>
      <path
        fill='#31a8ff'
        d='M166.06,18a13.94,13.94,0,0,1,9.9,4.1L211.9,58a13.94,13.94,0,0,1,4.1,9.9V224a14,14,0,0,1-14,14H54a14,14,0,0,1-14-14V32A14,14,0,0,1,54,18H166.06m0-10H54A24,24,0,0,0,30,32V224a24,24,0,0,0,24,24H202a24,24,0,0,0,24-24V67.94a24,24,0,0,0-7-17L183,15a24,24,0,0,0-17-7Z'
      ></path>
    </svg>
  );
};

//Microsoft Logos
export const WordLogo = ({
  className = "",
  width = 100,
  height = 100,
  alt = "Microsoft Word Logo",
}: LogoProps) => {
  return (
    <svg
      id='word'
      viewBox='0 0 190 166'
      width={width}
      height={height}
      className={className}
      role='img'
      aria-labelledby={alt}
    >
      <title id='logoTitle'>{alt}</title>
      <defs>
        <linearGradient id="linear-gradient" x1="-1029.7" y1="506.8" x2="-1030.7" y2="506.8" gradientTransform="translate(146406 84218.4) scale(142 -166)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#009ae3"/>
          <stop offset="1" stopColor="#0076b8"/>
        </linearGradient>
        <linearGradient id="linear-gradient1" x1="-1029.7" y1="500.3" x2="-1030.6" y2="501.2" gradientTransform="translate(146406 21094.5) scale(142 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0099f7"/>
          <stop offset="1" stopColor="#025fad"/>
        </linearGradient>
        <linearGradient id="linear-gradient2" x1="-1030.6" y1="501.3" x2="-1029.7" y2="500.3" gradientTransform="translate(146406 21052.5) scale(142 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0077b9"/>
          <stop offset="1" stopColor="#00a9f8"/>
        </linearGradient>
        <linearGradient id="linear-gradient3" x1="-1029.6" y1="500.2" x2="-1030.6" y2="501.2" gradientTransform="translate(146406 21136.5) scale(142 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0872d3"/>
          <stop offset="1" stopColor="#064c9f"/>
        </linearGradient>
        <linearGradient id="linear-gradient4" x1="-1029.7" y1="500.3" x2="-1030.7" y2="501.3" gradientTransform="translate(146406 21178.5) scale(142 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0d58bf"/>
          <stop offset="1" stopColor="#0a3070"/>
        </linearGradient>
        <linearGradient id="linear-gradient5" x1="-1027.2" y1="505.7" x2="-1026.1" y2="504.8" gradientTransform="translate(98610 48595.8) scale(96 -96)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0a3165"/>
          <stop offset="1" stopColor="#064995"/>
        </linearGradient>
        <radialGradient id="radial-gradient" cx="-1026.3" cy="505" fx="-1026.3" fy="505" r=".6" gradientTransform="translate(98610 48595.8) scale(96 -96)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#004f9d"/>
          <stop offset="1" stopColor="#004f9d" stopOpacity="0"/>
        </radialGradient>
        <linearGradient id="linear-gradient6" x1="-1021.7" y1="502" x2="-1021" y2="502" gradientTransform="translate(66137.6 25096.5) scale(64.7 -49.8)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#f0f0f0"/>
          <stop offset="1" stopColor="#fff"/>
        </linearGradient>
        <mask id="mask" x="48" y="0" width="142" height="166" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="mask-1" x="48" y="-1" width="142" height="167" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="mask-2" x="48" y="0" width="142" height="166" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="mask-3" x="48" y="0" width="142" height="167" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="mask-4" x="-10" y="0" width="200" height="166" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
      </defs>
      <rect width="142" height="166" x="48" y="0" fill="url(#linear-gradient)" rx="8" ry="8"/>
      <g mask="url(#mask)">
        <rect width="142" height="42" x="48" y="41" fill="url(#linear-gradient2)"/>
      </g>
      <g mask="url(#mask-1)">
        <rect width="142" height="42" x="48" y="-1" fill="url(#linear-gradient1)"/>
      </g>
      <g mask="url(#mask-2)">
        <rect width="142" height="42" x="48" y="83" fill="url(#linear-gradient3)"/>
      </g>
      <g mask="url(#mask-3)">
        <rect width="142" height="42" x="48" y="125" fill="url(#linear-gradient4)"/>
      </g>
      <g mask="url(#mask-4)">
        <path fill="#000" fillOpacity=".1" fillRule="evenodd" d="M8 37h80c4.4 0 8 3.6 8 8v80c0 4.4-13.6 18-18 18H-2c-4.4 0-8-3.6-8-8V55c0-4.4 13.6-18 18-18Z"/>
      </g>
      <g>
        <rect width="96" height="96" y="35" fill="url(#linear-gradient5)" rx="8" ry="8"/>
        <rect width="96" height="96" y="35" fill="url(#radial-gradient)" rx="8" ry="8"/>
        <path fill="url(#linear-gradient6)" fillRule="evenodd" d="m28.8 107.8-12.8-49.8h10.2l7.4 37.9 10-37.9h9.9l9.6 38.5 7.6-38.5h10l-13 49.8h-10.5l-8.8-38-8.8 38h-10.8Z"/>
      </g>
    </svg>
  );
};

export const ExcelLogo = ({
  className = "",
  width = 100,
  height = 100,
  alt = "Microsoft Excel Logo",
}: LogoProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 190 166"
      xmlns="http://www.w3.org/2000/svg"
      role='img'
      aria-labelledby={alt}
    >
      <title id='logoTitle'>{alt}</title>
      <defs>
        <linearGradient id="excel-linear-gradient" x1="-1023.3" y1="501.3" x2="-1022.4" y2="500.2" gradientTransform="translate(72708 21094.5) scale(71 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#007438"/>
          <stop offset="1" stopColor="#008b44"/>
        </linearGradient>
        <linearGradient id="excel-linear-gradient1" x1="-1022.3" y1="500.2" x2="-1023.3" y2="501.3" gradientTransform="translate(72779 21094.5) scale(71 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#00d576"/>
          <stop offset="1" stopColor="#00a054"/>
        </linearGradient>
        <linearGradient id="excel-linear-gradient2" x1="-1023.3" y1="501.3" x2="-1022.3" y2="500.2" gradientTransform="translate(72708 21052.5) scale(71 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#007e42"/>
          <stop offset="1" stopColor="#009a50"/>
        </linearGradient>
        <linearGradient id="excel-linear-gradient3" x1="-1023.3" y1="501.3" x2="-1022.3" y2="500.2" gradientTransform="translate(72779 21052.5) scale(71 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#00ad61"/>
          <stop offset="1" stopColor="#00e18c"/>
        </linearGradient>
        <linearGradient id="excel-linear-gradient4" x1="-1022.3" y1="500.2" x2="-1023.3" y2="501.2" gradientTransform="translate(72708 21136.5) scale(71 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#003d20"/>
          <stop offset="1" stopColor="#004f2a"/>
        </linearGradient>
        <linearGradient id="excel-linear-gradient5" x1="-1022.3" y1="500.2" x2="-1023.3" y2="501.2" gradientTransform="translate(72779 21136.5) scale(71 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#00c165"/>
          <stop offset="1" stopColor="#008d46"/>
        </linearGradient>
        <linearGradient id="excel-linear-gradient6" x1="-1022.3" y1="500.2" x2="-1023.3" y2="501.2" gradientTransform="translate(72708 21178.5) scale(71 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#00522e"/>
          <stop offset="1" stopColor="#003b20"/>
        </linearGradient>
        <linearGradient id="excel-linear-gradient7" x1="-1022.3" y1="500.2" x2="-1023.3" y2="501.2" gradientTransform="translate(72779 21178.5) scale(71 -42)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#006d3d"/>
          <stop offset="1" stopColor="#004c29"/>
        </linearGradient>
        <linearGradient id="excel-linear-gradient8" x1="-1026.1" y1="504.8" x2="-1027.2" y2="505.7" gradientTransform="translate(98610 48595.8) scale(96 -96)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#008034"/>
          <stop offset="1" stopColor="#004f21"/>
        </linearGradient>
        <radialGradient id="excel-radial-gradient" cx="-1026.3" cy="505" fx="-1026.3" fy="505" r=".6" gradientTransform="translate(98610 48595.8) scale(96 -96)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#018137"/>
          <stop offset="1" stopColor="#007e35" stopOpacity="0"/>
        </radialGradient>
        <linearGradient id="excel-linear-gradient9" x1="-1014.9" y1="502.1" x2="-1014.3" y2="502.1" gradientTransform="translate(46306.3 25241.2) scale(45.6 -50.1)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#f0f0f0"/>
          <stop offset="1" stopColor="#fff"/>
        </linearGradient>
        <mask id="excel-mask" x="48" y="0" width="142" height="166" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="excel-mask-1" x="48" y="0" width="142" height="166" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="excel-mask-2" x="48" y="-1" width="142" height="167" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="excel-mask-3" x="48" y="-1" width="142" height="167" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="excel-mask-4" x="48" y="0" width="142" height="166" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="excel-mask-5" x="48" y="0" width="142" height="166" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="excel-mask-6" x="48" y="0" width="142" height="167" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="excel-mask-7" x="48" y="0" width="142" height="167" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="excel-mask-8" x="-10" y="0" width="200" height="166" maskUnits="userSpaceOnUse">
          <rect width="142" height="166" x="48" y="0" fill="#fff" rx="8" ry="8"/>
        </mask>
        <mask id="excel-mask-9" x="0" y="35" width="96" height="96" maskUnits="userSpaceOnUse">
          <rect width="96" height="96" y="35" fill="#fff" rx="8" ry="8"/>
        </mask>
      </defs>
      <g>
        <g mask="url(#excel-mask)">
          <rect width="71" height="42" x="48" y="41" fill="url(#excel-linear-gradient)"/>
        </g>
        <g mask="url(#excel-mask-1)">
          <rect width="71" height="42" x="119" y="41" fill="url(#excel-linear-gradient1)"/>
        </g>
        <g mask="url(#excel-mask-2)">
          <rect width="71" height="42" x="48" y="-1" fill="url(#excel-linear-gradient2)"/>
        </g>
        <g mask="url(#excel-mask-3)">
          <rect width="71" height="42" x="119" y="-1" fill="url(#excel-linear-gradient3)"/>
        </g>
        <g mask="url(#excel-mask-4)">
          <rect width="71" height="42" x="48" y="83" fill="url(#excel-linear-gradient4)"/>
        </g>
        <g mask="url(#excel-mask-5)">
          <rect width="71" height="42" x="119" y="83" fill="url(#excel-linear-gradient5)"/>
        </g>
        <g mask="url(#excel-mask-6)">
          <rect width="71" height="42" x="48" y="125" fill="url(#excel-linear-gradient6)"/>
        </g>
        <g mask="url(#excel-mask-7)">
          <rect width="71" height="42" x="119" y="125" fill="url(#excel-linear-gradient7)"/>
        </g>
      </g>
      <g mask="url(#excel-mask-8)">
        <path fillOpacity=".1" fillRule="evenodd" d="M8 37h80c4.4 0 8 3.6 8 8v80c0 4.4-13.6 18-18 18H-2c-4.4 0-8-3.6-8-8V55c0-4.4 13.6-18 18-18Z"/>
      </g>
      <g>
        <rect width="96" height="96" y="35" fill="url(#excel-linear-gradient8)" rx="8" ry="8"/>
        <rect width="96" height="96" y="35" fill="url(#excel-radial-gradient)" rx="8" ry="8"/>
        <g mask="url(#excel-mask-9)">
          <path fill="url(#excel-linear-gradient9)" fillRule="evenodd" d="M25 108.1l16.8-26.1L26.6 58h11.5L48 76.1 57.6 58h11.5l-15.3 24.3 16.8 25.8H58.6l-10.8-19.3-10.9 19.3H25z"/>
        </g>
      </g>
    </svg>
  )
};

export const PowerPointLogo = ({
  className = "",
  width = 100,
  height = 100,
  alt = "Microsoft PowerPoint Logo",
}: LogoProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 191 166"
      xmlns="http://www.w3.org/2000/svg"
      role='img'
      aria-labelledby={alt}
    >
      <title id='logoTitle'>{alt}</title>
      <defs>
        <linearGradient id="ppt-linear-gradient" x1="-1030.7" y1="506.5" x2="-1031.6" y2="507.1" gradientTransform="translate(171295 84218.4) scale(166 -166)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ff4619"/>
          <stop offset="1" stopColor="#871d08"/>
        </linearGradient>
        <linearGradient id="ppt-linear-gradient1" x1="-1024.6" y1="504.3" x2="-1025.4" y2="505.3" gradientTransform="translate(85224 41938.7) scale(83 -83)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ffc896"/>
          <stop offset="1" stopColor="#eb875a"/>
        </linearGradient>
        <linearGradient id="ppt-linear-gradient2" x1="-1024.5" y1="504.3" x2="-1025.4" y2="505.2" gradientTransform="translate(85141 41938.7) scale(83 -83)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ee6d43"/>
          <stop offset="1" stopColor="#b65737"/>
        </linearGradient>
        <linearGradient id="ppt-linear-gradient3" x1="-1027.2" y1="505.7" x2="-1026.1" y2="504.8" gradientTransform="translate(98610 48595.8) scale(96 -96)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#75200e"/>
          <stop offset="1" stopColor="#bb3212"/>
        </linearGradient>
        <radialGradient id="ppt-radial-gradient" cx="-1026.3" cy="505" fx="-1026.3" fy="505" r=".6" gradientTransform="translate(98610 48595.8) scale(96 -96)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#bb3112"/>
          <stop offset="1" stopColor="#bb3112" stopOpacity="0"/>
        </radialGradient>
        <linearGradient id="ppt-linear-gradient4" x1="-1011" y1="501.9" x2="-1010.3" y2="501.9" gradientTransform="translate(39286.5 24684.3) scale(38.8 -49)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#f0f0f0"/>
          <stop offset="1" stopColor="#fff"/>
        </linearGradient>
        <mask id="ppt-mask" x="25" y="0" width="166" height="166" maskUnits="userSpaceOnUse">
          <circle cx="108" cy="83" r="83" fill="#fff"/>
        </mask>
        <mask id="ppt-mask-1" x="25" y="0" width="166" height="166" maskUnits="userSpaceOnUse">
          <circle cx="108" cy="83" r="83" fill="#fff"/>
        </mask>
        <mask id="ppt-mask-2" x="-9" y="0" width="200" height="166" maskUnits="userSpaceOnUse">
          <circle cx="108" cy="83" r="83" fill="#fff"/>
        </mask>
      </defs>
      <g>
        <circle cx="108" cy="83" r="83" fill="url(#ppt-linear-gradient)"/>
        <g mask="url(#ppt-mask)">
          <rect width="83" height="83" x="108" y="0" fill="url(#ppt-linear-gradient1)"/>
        </g>
        <g mask="url(#ppt-mask-1)">
          <rect width="83" height="83" x="25" y="0" fill="url(#ppt-linear-gradient2)"/>
        </g>
      </g>
      <g mask="url(#ppt-mask-2)">
        <path 
          fillOpacity=".1" 
          fillRule="evenodd" 
          d="M9,35h80c4.4,0,8,3.6,8,8v80c0,4.4-13.6,18-18,18H-1c-4.4,0-8-3.6-8-8V53c0-4.4,13.6-18,18-18Z"
        />
      </g>
      <g>
        <rect width="96" height="96" y="35" fill="url(#ppt-linear-gradient3)" rx="8" ry="8"/>
        <rect width="96" height="96" y="35" fill="url(#ppt-radial-gradient)" rx="8" ry="8"/>
        <path 
          fill="url(#ppt-linear-gradient4)" 
          fillRule="evenodd"
          d="M39,90.1v16.9h-10v-49h20.3c12.4,0,18.5,5.2,18.5,15.6s-1.8,8.9-5.3,11.9-8.3,4.6-14.2,4.6h-9.3ZM39,65.5v16.3h8.8c6.2,0,9.3-2.7,9.3-8.2s-3.1-8-9.3-8h-8.8Z"
        />
      </g>
    </svg>
  )
};